import PeopleWidgetWithOutHolo from 'Components/common/components/PeopleWidgetWithOutHolo';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { NotificationAlerts, NotificationOpenedRequest } from 'Types/CompaniesTypes';
import { backgroundColorParsing, getQueryPersonId, valueToObject } from 'Utils/UtilityFunctions';
import { actions as notesSlice } from 'Slice/NotesSlice';
import { actions as uiSlice } from 'Slice/UISlice';
import {
  maxWidth, primaryFont, retina, wMBold, wMedium,
} from 'Utils/utilsStyle';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { COMPANY_OVERVIEW_ROUTE, GROUP_DETAIL_ROUTE, PERSONALITY_INSIGHTS_ROUTE } from 'Utils/Constants';
import { actions as alertActions } from '../../../Slice/AlertsSlice';

type Props = {
  notification: NotificationAlerts,
  isRead?: boolean,
  personType?: string,
  closeDrawer?: () => void,
} & typeof defaultProps;

const defaultProps = {
  isRead: false,
  personType: 'EXECUTIVE',
  closeDrawer: () => { },
};

const ArticleWrapper = styled.div`
&.article-item {
    padding: 10px 10px 10px 5px;
    border-radius: 10px;
    margin-bottom: 8px;
}
  .ant-popover-inner {
    border-radius: 16px;
    .ant-popover-inner-content{
      padding: 0;
    }
  }
  .text-area {
    position: relative;
    padding: 0px 10px 10px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      padding: 6px 10px 10px;
      }
    .message {
      &.notBold {
        font-weight: ${wMedium};
        margin-left: 3px;
      }
      font-family: ${primaryFont};
      font-weight: ${wMBold};
      font-size: 14px;
      letter-spacing:-0.27px;
      line-height: 17px;
      color:#001760;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 12px;
        line-height: 14px;
      }
    }
    .date {
      font-family: ${primaryFont};
      font-weight: ${wMedium};
      font-size: 11px;
      line-height: 12px;
      color: #7E7E7E;
      margin-top: 4px;
       @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 10px;
        margin-top: 2px;
      }
    }
  }
`;

const NotificationItem = function NotificationItem(props: Props) {
  const {
    notification,
    isRead,
    personType,
    closeDrawer,
  } = props;

  const {
    personalityTypes, personId, personImage, personName,
    personDesignation, newCompany, oldCompany, date: joinDate, dateTimeStamp,
    messageType, notificationType, notificationID, groupName, id,
    groupId, noteAddOnPersonId, noteAddedOnPersonName, noteAddOnCompanyId, noteAddedOnCompanyName,
  } = notification;
  const shareBuyerGroup = 'ShareBuyerGroup';
  const personQueryId: number = getQueryPersonId();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const host = window.location.href;

  const navigateTo = () => {
    dispatch(notesSlice.setAlertsNotificationId(notificationID));
    if (notificationType === 'person') {
      const mType = messageType.toLowerCase();
      let type = '';
      switch (mType) {
        case 'company':
          type = 'job_change';
          break;
        case 'sharebuyergroup':
          type = 'buyer_group_shared';
          break;
        case 'persontag':
          type = 'notes_tagged';
          break;
        case 'person':
          type = 'notes_add';
          break;
        case 'designation':
          type = 'designation_change';
          break;
        default:
          type = '';
      }
      if (mType.includes('company') && noteAddOnCompanyId) {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('alertPanel_companyNotes_clicked', 0, {
            host,
          }),
        ));
      } else {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('alertPanel_people_clicked', 0, {
            ...type && { alert_selected: type },
            host,
          }),
        ));
        if (messageType === 'Person' || messageType === 'PersonTag') {
          dispatch(uiSlice.isToastNeedToOpen(true));
        }
      }

      if (messageType === shareBuyerGroup && groupId) {
        navigate(`${GROUP_DETAIL_ROUTE}${groupId}`);
      } else if ((messageType === 'Person' || messageType === 'PersonTag') && noteAddOnPersonId) {
        navigate(`${PERSONALITY_INSIGHTS_ROUTE}${noteAddOnPersonId}&personType=${personType}&isNotes=true`);
      } else if ((messageType === 'Company' || messageType === 'CompanyTag') && !newCompany && noteAddOnCompanyId) {
        navigate(`${COMPANY_OVERVIEW_ROUTE}${noteAddOnCompanyId}&isNotes=true`);
      } else if (messageType === 'Company' && newCompany && personId) {
        navigate(`${PERSONALITY_INSIGHTS_ROUTE}${personId}&personType=${personType}`);
      } else if (personId && personQueryId !== personId) {
        navigate(`${PERSONALITY_INSIGHTS_ROUTE}${personId}&personType=${personType}`);
      }
      const notificationData: NotificationOpenedRequest = {
        notificationID: id,
        messageType,
      };
      if (!isRead) dispatch(alertActions.getNotificationOpened(notificationData));
      closeDrawer();
    }
  };

  return (
    <ArticleWrapper onClick={navigateTo} className={`article-item alert-article ${isRead ? '' : 'active'}`}>
      <div role="button" tabIndex={0}>
        <PeopleWidgetWithOutHolo
          key={personId}
          diameter="54px"
          diameterSm="54px"
          diameterXsm="54px"
          imageClassName="person-image"
          marginSm="0px 0px 0px 0px"
          margin="0px 0px 0px 0px"
          wrapperColor={backgroundColorParsing(personalityTypes)}
          logo={personImage}
          personId={personId}
          ringPadding="3px"
          ringPaddingSm="3px"
          disableNavigation
        />
      </div>
      {messageType === 'Person' && noteAddedOnPersonName ? (
        <div className="text-area">
          <span
            className="message text-truncate-three-line"
          >
            {personName}
            <span className="message notBold">
              has posted a note on
              {' '}
              <span className="message">
                {noteAddedOnPersonName}
                &apos;s
                {' '}
              </span>
              profile on
              {' '}
              {joinDate}
            </span>
          </span>
          <span
            className="date text-truncate-one-line"
          >
            {dateTimeStamp}
          </span>
        </div>
      ) : null}
      {messageType === 'PersonTag' ? (
        <div className="text-area">
          <span
            className="message text-truncate-three-line"
          >
            {personName}
            <span className="message notBold">
              mentioned you in a note on
              {' '}
              <span className="message">
                {noteAddedOnPersonName}
                &apos;s
                {' '}
              </span>
              profile on
              {' '}
              {joinDate}
            </span>
          </span>
          <span
            className="date text-truncate-one-line"
          >
            {dateTimeStamp}
          </span>
        </div>
      ) : null}
      {messageType === 'Company' && noteAddedOnCompanyName ? (
        <div className="text-area">
          <span
            className="message text-truncate-three-line"
          >
            {personName}
            <span className="message notBold">
              has posted a note on
              {' '}
              <span className="message">
                {noteAddedOnCompanyName}
                &apos;s
                {' '}
              </span>
              profile on
              {' '}
              {joinDate}
            </span>
          </span>
          <span
            className="date text-truncate-one-line"
          >
            {dateTimeStamp}
          </span>
        </div>
      ) : null}
      {messageType === 'CompanyTag' ? (
        <div className="text-area">
          <span
            className="message text-truncate-three-line"
          >
            {personName}
            <span className="message notBold">
              mentioned you in a note on
              {' '}
              <span className="message">
                {noteAddedOnCompanyName}
                &apos;
                {' '}
              </span>
              profile on
              {' '}
              {joinDate}
            </span>
          </span>
          <span
            className="date text-truncate-one-line"
          >
            {dateTimeStamp}
          </span>
        </div>
      ) : null}
      {messageType === 'Designation'
        ? (
          <div className="text-area">
            <span
              className="message text-truncate-three-line"
            >
              {personName}
              <span className="message notBold">has moved to a new role as a </span>
              {personDesignation}
              <span className="message notBold">at </span>
              {oldCompany}
              <span className="message notBold">on </span>
              {joinDate}
            </span>
            <span
              className="date text-truncate-one-line"
            >
              {dateTimeStamp}
            </span>
          </div>
        ) : null}
      {messageType === shareBuyerGroup ? (
        <div className="text-area">
          <span
            className="message text-truncate-three-line"
          >
            {personName}
            <span className="message notBold">shared the group </span>
            {groupName}
            <span className="message notBold">
              with you on
              {' '}
              {joinDate}
            </span>
          </span>
          <span
            className="date text-truncate-one-line"
          >
            {dateTimeStamp}
          </span>
        </div>
      ) : null}
      {messageType === 'Company' && newCompany ? (
        <div className="text-area">
          <span
            className="message text-truncate-three-line"
          >
            {personName}
            <span className="message notBold">has moved to </span>
            {newCompany}
            <span className="message notBold">from </span>
            {oldCompany}
            <span className="message notBold">as a </span>
            {personDesignation}
            <span className="message notBold">on </span>
            {joinDate}
          </span>
          <span
            className="date text-truncate-one-line"
          >
            {dateTimeStamp}
          </span>
        </div>
      ) : null}
      {messageType === 'UnemployedPerson' ? (
        <div className="text-area">
          <span
            className="message text-truncate-three-line"
          >
            {personName}
            <span className="message notBold">has left their position at </span>
            {oldCompany}
            <span className="message notBold">as of </span>
            {joinDate}
          </span>
          <span
            className="date text-truncate-one-line"
          >
            {dateTimeStamp}
          </span>
        </div>
      ) : null}
    </ArticleWrapper>
  );
};
NotificationItem.defaultProps = defaultProps;
export default NotificationItem;
